
import { Component, Prop, Vue } from "vue-property-decorator";
import { Candidate, CandidateResult } from "@/lib/model/exam/result";
import DescribeData from "@/views/paper/paper-result-report/component/describe.vue";
import EnglishAssessmentResult from "@/views/paper/paper-result-report/english";
import * as echarts from "echarts";

type EChartsOption = echarts.EChartsOption;

@Component({
  components: { DescribeData }
})
export default class EnglishProficiency extends Vue {
  @Prop() index!: number;
  @Prop({ type: CandidateResult, default: () => new CandidateResult() })
  all!: CandidateResult; //候选人信息 所有表
  @Prop({ type: Candidate, default: () => new Candidate() })
  candidate!: CandidateResult; //候选人信息 主表
  option: EChartsOption = {};

  get englishData() {
    const a = new EnglishAssessmentResult().assign(
      this.all.englishAssessmentResult
    );
    return a;
  }

  // 是否存在雷达图
  get isShowRadarMap() {
    const isShow =
      this.all.reportShowConfig.englishAssessmentShowType === 1 &&
      this.englishData.unPronFluency() &&
      this.englishData.unPronAccuracy() &&
      this.englishData.unLexicalRichness() &&
      this.englishData.unGrammarAccuracy();
    if (!isShow) {
      this.$nextTick(() => {
        const chartDom = document.getElementById("radarMap") as HTMLElement;
        const myChart = echarts.init(chartDom, undefined, { renderer: "svg" });
        this.option = {
          radar: {
            indicator: [
              { text: this.pronFluency.label, max: 9 },
              { text: this.pronAccuracy.label, max: 9 },
              { text: this.lexicalRichness.label, max: 9 },
              { text: this.grammarAccuracy.label, max: 9 }
            ],
            center: ["50%", "168"],
            radius: "70%",
            splitArea: {
              areaStyle: {
                color: [] //圆环颜色
              }
            },
            axisName: {
              formatter: (param: string | undefined): string => {
                if (param && ["发音准确度", "语法准确度"].includes(param)) {
                  return `{center|${param.slice(0, 2)}}\n{center|${param.slice(
                    2
                  )}}`;
                } else {
                  return `{center|${param}}`;
                }
              },
              rich: {
                center: {
                  align: "center",
                  lineHeight: 18,
                  fontWeight: "normal",
                  fontSize: 14,
                  color: "#111111"
                }
              }
            },
            axisLine: {
              // 坐标轴线
              lineStyle: {
                width: 1,
                color: "#E7E7E7" // 图表背景网格线的颜色
              }
            },
            splitLine: {
              // 网格线
              lineStyle: {
                width: 1,
                color: "#E7E7E7"
              }
            }
          },
          series: [
            {
              type: "radar",
              animation: false,
              data: [
                {
                  value: [9, 9, 9, 9],
                  emphasis: {
                    disabled: true
                  },
                  symbol: "circle",
                  symbolSize: 14,
                  itemStyle: {
                    color: "#fff",
                    borderWidth: 1,
                    borderColor: "#e7e7e7"
                  },
                  // cursor: "default",
                  lineStyle: {
                    color: "#e7e7e7",
                    width: 1
                  }
                }
              ]
            },
            {
              type: "radar",
              areaStyle: {
                color: "rgba(86, 84, 220, 0.20)"
              },
              symbol: "circle",
              symbolSize: 12,
              itemStyle: {
                color: "#5654DC",
                borderWidth: 2,
                borderColor: "#fff"
              },
              data: [
                {
                  value: [
                    this.englishData.pronFluencyLevel,
                    this.englishData.pronAccuracyLevel,
                    this.englishData.lexicalRichnessLevel,
                    this.englishData.grammarAccuracyLevel
                  ]
                }
              ]
            }
          ]
        };

        this.option && myChart.setOption(this.option);
      });
    }
    return !isShow;
  }
  get tableList() {
    return this.englishData.getTable();
  }
  // 总评估
  get totalLevel() {
    return this.englishData.getLevel("totalLevel", true);
  }
  // 表达流利度考察点
  get pronFluency() {
    return this.englishData.getLevel("pronFluencyLevel");
  }
  // 发音准确度考察点
  get pronAccuracy() {
    return this.englishData.getLevel("pronAccuracyLevel");
  }
  // 词汇丰富度考察点
  get lexicalRichness() {
    return this.englishData.getLevel("lexicalRichnessLevel");
  }
  // 语法准确度考察点
  get grammarAccuracy() {
    return this.englishData.getLevel("grammarAccuracyLevel");
  }
}
